module.exports = __webpack_public_path__ + "img/guide-icon.5945f69d.svg";